import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../connection/api';
import alert_msg from '../../../alert/alert_msg';
import alert_box from '../../../alert/alert_box';
export default function AddBase({ onAddBase }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    base_name: '',
    circle_id: '',
    // address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log('chanfe'+e.target.value);
    setFormData(prev => {
      const newState = { ...prev, [name]: value };
      // Clear error for this field when user starts typing
      if (errors[name]) {
        setErrors(prevErrors => ({ ...prevErrors, [name]: [] }));
      }
      return newState;
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    
    
  const  token = localStorage.getItem("token");
const  response=await api.post("base/add", formData, {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});
 if (response.data.success === true) {
  navigate('/bases');
    alert_msg('بنکەی نوێ بە سەرکەوتوویی زیادکرا','success');
 }
 else{
  alert_box('هەڵە ڕیدا',response.data.message,'error','ok');
 }
    
    
  };
  const renderFieldErrors = (fieldName) => {
    if (errors[fieldName] && errors[fieldName].length > 0) {
      return (
        <div className="field-errors">
          {errors[fieldName].map((error, index) => (
            <div key={index} className="error-message">
              {error}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };
  const handleCancel = () => {
    navigate('/bases');
  };

  // const regions = ['سلێمانی', 'هەولێر', 'دهۆک', 'هەڵەبجە'];
  const [bazna, setBazna] = useState([]);
  const [errors, setErrors] = useState({});

  const getCircle = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/circle/index", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      setBazna(response.data.AllData);
      console.log(localStorage.getItem('role'));
      // console.log(bazna.circle_name);
    } catch (error) {
      console.error("Error fetching circles:", error);
    }
  };

  useEffect(() => {
    getCircle();
  }, []);


  return (
    <div className="page active">
      <div className="page-header">
        <h1>زیادکردنی بنکەیەکی نوێ</h1>
        <p>زانیاری بنکەی نوێ تۆمار بکە</p>
      </div>

      <div className="form-page">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">ناوی بنکە *</label>
            <input 
              type="text" 
              id="base_name" 
              name="base_name" 
              required
              value={formData.base_name}
              onChange={handleChange}
              placeholder="نموونە: ئەحمەدی خانی"
            />
          </div>

          <div className="form-group">
            <label htmlFor="circle_id">بازنە *</label>
            <select 
              id="circle_id" 
              name="circle_id" 
              required
              value={formData.circle_id}
              onChange={handleChange}
              className={errors.circle_id ? 'has-error' : ''}
            >
              <option value="">بازنە هەڵبژێرە</option>
              {/* {renderOptions(bazna)} */}
               {localStorage.getItem('role')==='admin' && bazna  && ( 
           <option key={bazna.id} value={bazna.id}>
           {bazna.circle_name}
         </option>
      
               )} 

               {localStorage.getItem('role')==='superadmin' && bazna  && Array.isArray(bazna) && bazna.length > 1 && bazna.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.circle_name}
                </option>
              )) 
           }
              
              
            </select>
            {/* {renderFieldErrors('circle_id')} */}
          </div>
          {/* <div className="form-group">
            <label htmlFor="address">ناونیشان *</label>
            <input 
              type="text" 
              id="address" 
              name="address" 
              required
              value={formData.address}
              onChange={handleChange}
              placeholder="نموونە: ناوچەی ئەحمەدی خانی، سلێمانی"
            />
          </div> */}

<div className="form-actions">
            <button type="submit" className="btn-primary">
              <i className="fas fa-save"></i>
              خەزن بکە
            </button>
            <button type="button" className="btn-secondary" onClick={handleCancel}>
              <i className="fas fa-arrow-right"></i>
              گەڕانەوە
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
